"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeType = exports.NodeEvaluationVisit = void 0;
const utils_1 = require("../utils");
var NodeType;
(function (NodeType) {
    NodeType["SectionGroup"] = "SectionGroup";
    NodeType["Section"] = "Section";
    NodeType["Subsection"] = "Subsection";
    NodeType["FieldGroup"] = "FieldGroup";
    NodeType["Field"] = "Field";
    NodeType["Option"] = "Option";
})(NodeType || (exports.NodeType = NodeType = {}));
class NodeEvaluationVisit {
    answersResolver;
    evalVisitor;
    extractRule;
    resultStack = (0, utils_1.createStack)();
    constructor(answersResolver, evalVisitor, extractRule) {
        this.answersResolver = answersResolver;
        this.evalVisitor = evalVisitor;
        this.extractRule = extractRule;
    }
    visitFor(node, visitChildren, options) {
        const { nodeType, repeatedInstanceIdentifiers } = options;
        const visitFunctionName = `visit${nodeType}`;
        const visit = this.evalVisitor[visitFunctionName] ?? this.evalVisitor.visitDefault;
        const currentResults = this.resultStack.peek() ?? [];
        const childrenResults = [];
        this.resultStack.push(childrenResults);
        const extractedRule = this.extractRule ? this.extractRule(node) : undefined;
        const visitResult = visit({
            visitChildren,
            childrenResults: () => childrenResults,
        }, {
            node,
            repeatedInstanceIdentifiers,
            rule: extractedRule,
            answersResolver: this.answersResolver,
        });
        currentResults.push(visitResult);
        this.resultStack.pop();
    }
}
exports.NodeEvaluationVisit = NodeEvaluationVisit;
